// De profielfoto van de ingelogde gebruiker (Voorkeuren → Profiel, en de avatar in de zijbalk).
//
// Twee calls die de generieke Refine dataProvider niet kan maken: de upload is multipart en de bytes
// zitten achter de bearer (in het geheugen, niet in een cookie), dus een <img src> krijgt ze niet.
// Zelfde patroon als src/api/animalPhoto.ts.
import { getAccessToken } from "../auth";

const API_URL = (import.meta.env.VITE_API_URL as string | undefined) ?? "/api";

function authHeaders(): Record<string, string> {
  const token = getAccessToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

/** De eigen profielfoto vervangen. JPG of PNG, maximaal 2 MB (de api dwingt dat ook af). */
export async function uploadProfielfoto(file: File): Promise<void> {
  const form = new FormData();
  form.append("file", file);
  const res = await fetch(`${API_URL}/auth/me/photo`, {
    method: "POST",
    headers: authHeaders(), // geen Content-Type — de browser zet de multipart-boundary
    body: form,
  });
  if (!res.ok) {
    throw new Error(`HTTP ${res.status}`);
  }
}

/** De eigen profielfoto weghalen. */
export async function verwijderProfielfoto(): Promise<void> {
  const res = await fetch(`${API_URL}/auth/me/photo`, { method: "DELETE", headers: authHeaders() });
  if (!res.ok) {
    throw new Error(`HTTP ${res.status}`);
  }
}

/**
 * De bytes van de eigen profielfoto als object-URL, of null als er geen foto is. Een mislukte call is
 * hier geen fout maar "geen foto": de zijbalk valt terug op het silhouet en de app draait door.
 */
export async function profielfotoUrl(): Promise<string | null> {
  try {
    const res = await fetch(`${API_URL}/auth/me/photo/content`, { headers: authHeaders() });
    if (!res.ok) {
      return null;
    }
    return URL.createObjectURL(await res.blob());
  } catch {
    return null;
  }
}

/**
 * De zijbalk toont dezelfde foto als de dialoog. Na een upload of een verwijdering roept de dialoog dit
 * aan; de zijbalk luistert en haalt de foto opnieuw op — anders zou je pas na herladen je eigen nieuwe
 * foto zien.
 */
export const FOTO_GEWIJZIGD = "fawkes:profielfoto";

export function meldFotoGewijzigd(): void {
  globalThis.dispatchEvent?.(new Event(FOTO_GEWIJZIGD));
}
